<template>
    <div class="background-educacao pa-4" style="height: 100vh; letter-spacing: 0.0892857143em font;" >
        <header> 
            <div class="text-center">
                <img class="img-fluid mt-1" :src="require('@/assets/img/titulo.png')"  alt="brasão">
            </div>
        </header>
        <v-banner 
        outlined
        rounded
        sticky
        color="#2D6989">
            <div class=" d-flex flex-row justify-space-between text-subtitle-1" >
                <div class="white--text">Matrícula: {{ dados.cdlogin.toLowerCase() }}</div>
                <div class="white--text ml-4">Nome completo: {{ dados.dadosFuncionario.nmfuncion }}</div>
                <div class="white--text ml-auto">
                    <router-link :to="{name: 'distribuicao-de-aulas'}" style="text-decoration: none;"> 
                        <v-icon color="#FFFF" left>
                            mdi-exit-to-app
                        </v-icon>
                        <span class="p-1" style="font-weight: bold; color: #FFFF;">Voltar</span>
                    </router-link> 
                </div>
                            
            </div>
        </v-banner>
        <v-card  >
            <v-tabs :vertical="(this.ehMobile()) ? false : true"   :horizontal="(this.ehMobile()) ? true : false" style="border: solid; border-color: #FFFF; border-width: 1px 0px 1px 0px;">
                <v-tab class="white--text" style="border: solid; border-color: #FFFF; border-width: 0px 0px 1px 0px;" >
                    <v-icon color="#FFFF" left>
                    mdi-human-queue
                    </v-icon>
                    Ranking
                    
                </v-tab>
                <v-tab class="white--text" style="border: solid; border-color: #FFFF; border-width: 0px 0px 1px 0px;">
                    <v-icon color="#FFFF" left >
                    mdi-newspaper-variant-outline
                    </v-icon >
                    Inscrições
                </v-tab>
                <v-tab class="white--text"  style="border: solid; border-color: #FFFF; border-width: 0px 0px 1px 0px;">
                    <v-icon color="#FFFF" left>
                    mdi-check-all
                    </v-icon>
                    Efetivações
                </v-tab>
            <v-tab-item class="p-4" >
                <v-card flat>
                <v-card-text style="letter-spacing: 0.0892857143em">
                    <v-row class="mb-4" justify="center" v-if="agendamentoRankingPEB40Hs && posicaoRankingPEB40Hs">
                        <v-expansion-panels  >
                            <v-expansion-panel>
                                <v-expansion-panel-header color="#198754" class="text-light text-subtitle-1 font-weight-bold">PEB 40Hs
                                        <template v-slot:actions>
                                            <v-icon color="white">
                                            mdi-menu-down
                                            </v-icon>
                                        </template>
                                </v-expansion-panel-header>
                                    <v-expansion-panel-content class="p-4">
                                        <v-simple-table>
                                            <thead>
                                                <tr>
                                                    <th class="text-left text-subtitle-1 font-weight-bold " >Critério do ranking</th>
                                                    <th class="text-left text-subtitle-1 font-weight-light " >Ordem crescente de matrícula</th>
                                                </tr>
                                                <tr>
                                                    <th class="text-left text-subtitle-1 font-weight-bold " >Posição no ranking</th>
                                                    <th class="text-left text-subtitle-1 font-weight-light " >{{`${posicaoRankingPEB40Hs}º lugar`}}</th>
                                                </tr>
                                                <tr>
                                                    <th class="text-left text-subtitle-1 font-weight-bold " >Agendamento da efetivação das aulas</th>
                                                    <th class="text-left text-subtitle-1 font-weight-light " >{{`${agendamentoRankingPEB40Hs.tsacessoin} as 
                                                                                                                ${agendamentoRankingPEB40Hs.tsacessofi}`}}</th>
                                                </tr>
                                            </thead>
                                        </v-simple-table>
                                    </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-row>

                    <v-row class="mb-4" justify="center" v-if="agendamentoRankingPrimeiroCargo && posicaoRankingPrimeiroCargo">
                        <v-expansion-panels height="100px" >
                            <v-expansion-panel >
                                <v-expansion-panel-header color="#198754" class="text-light text-subtitle-1 font-weight-bold">
                                        1º CARGO
                                        <template v-slot:actions>
                                            <v-icon color="white">
                                            mdi-menu-down
                                            </v-icon>
                                        </template>

                                </v-expansion-panel-header>
                                    <v-expansion-panel-content class="p-4">
                                        <v-simple-table>
                                            <thead>
                                                <tr>
                                                    <th class="text-left text-subtitle-1 font-weight-bold " >Critério do ranking</th>
                                                    <th class="text-left text-subtitle-1 font-weight-light " >Ordem crescente de matrícula</th>
                                                </tr>
                                                <tr>
                                                    <th class="text-left text-subtitle-1 font-weight-bold " >Posição no ranking</th>
                                                    <th class="text-left text-subtitle-1 font-weight-light " >{{`${posicaoRankingPrimeiroCargo}º lugar`}}</th>
                                                </tr>
                                                <tr>
                                                    <th class="text-left text-subtitle-1 font-weight-bold " >Agendamento da efetivação das aulas</th>
                                                    <th class="text-left text-subtitle-1 font-weight-light " >{{`${agendamentoRankingPrimeiroCargo.tsacessoin} as 
                                                                                                            ${agendamentoRankingPrimeiroCargo.tsacessofi}`}}</th>
                                                </tr>
                                            </thead>
                                        </v-simple-table>
                                    </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-row>

                    <v-row justify="center" v-if="agendamentoExtensaoCH && posicaoRankingExtensaoCH">
                        <v-expansion-panels  >
                        <v-expansion-panel>
                            <v-expansion-panel-header color="#198754" class="text-light text-subtitle-1 font-weight-bold">
                                EXTENSÃO DE CARGA HORÁRIA
                                    <template v-slot:actions>
                                        <v-icon color="white">
                                        mdi-menu-down
                                        </v-icon>
                                    </template>


                            </v-expansion-panel-header>
                                <v-expansion-panel-content class="p-4">
                                        <v-simple-table>
                                            <thead>
                                                <tr>
                                                    <th class="text-left text-subtitle-1 font-weight-bold " >Critério do ranking</th>
                                                    <th class="text-left text-subtitle-1 font-weight-light " >Ordem crescente de pontuação</th>
                                                </tr>
                                                <tr>
                                                    <th class="text-left text-subtitle-1 font-weight-bold " >Posição no ranking</th>
                                                    <th class="text-left text-subtitle-1 font-weight-light " >{{`${posicaoRankingExtensaoCH}º lugar`}}</th>
                                                </tr>
                                                <tr>
                                                    <th class="text-left text-subtitle-1 font-weight-bold " >Agendamento da efetivação das aulas</th>
                                                    <th class="text-left text-subtitle-1 font-weight-light " >{{`${agendamentoExtensaoCH.tsacessoin} as 
                                                                                                                ${agendamentoExtensaoCH.tsacessofi}`}}</th>
                                                </tr>
                                            </thead>
                                            <thead >
                                                <tr>
                                                    <th class="text-center text-subtitle-1 font-weight-bold " colspan="2">Detalhamento da pontuação</th>
                                                </tr>
                                            </thead>
                                            <thead class="font-weight-light">
                                                <tr>
                                                    <th class="text-left text-subtitle-1 font-weight-bold">
                                                        Pós-graduação
                                                    </th>
                                                    
                                                    <th class="text-left text-subtitle-1 font-weight-light">
                                                        {{ pontuacaoRankingExtensaoCH.pontos_pos_grad }}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th class="text-left text-subtitle-1 font-weight-bold">
                                                        Mestrado
                                                    </th>
                                                    <th class="text-left text-subtitle-1 font-weight-light">
                                                        {{ pontuacaoRankingExtensaoCH.pontos_mestrado }}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th class="text-left text-subtitle-1 font-weight-bold">
                                                        Tempo de extensão
                                                    </th>
                                                    <th class="text-left text-subtitle-1 font-weight-light">
                                                        {{ pontuacaoRankingExtensaoCH.pontos_ext_ch }}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th class="text-left text-subtitle-1 font-weight-bold">
                                                        Avaliação de desempenho
                                                    </th>
                                                    <th class="text-left text-subtitle-1 font-weight-light">
                                                        {{ pontuacaoRankingExtensaoCH.nota_avaliacao }}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th class="text-left text-subtitle-1 font-weight-bold">
                                                        Total
                                                    </th>
                                                    <th class="text-left text-subtitle-1 font-weight-light">
                                                        {{ pontuacaoRankingExtensaoCH.total_pontos }}
                                                    </th>
                                                </tr>
                                            </thead>
                                        </v-simple-table>
                                </v-expansion-panel-content>
                        </v-expansion-panel>
                        </v-expansion-panels>
                    </v-row>
                    
                    
                    
                </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <v-row class="mb-4 p-4" justify="center">
                            <v-simple-table>
                                <thead>
                                    <tr>
                                        <th class="text-left text-subtitle-1 font-weight-bold" >Ano letivo</th>
                                        <th class="text-left text-subtitle-1 font-weight-light" colspan="4" >{{ inscricao.aaletivo }}</th>
                                    </tr>
                                    <tr>
                                        <th class="text-left text-subtitle-1 font-weight-bold" >Inscrição 1º cargo</th>
                                        <th class="text-left text-subtitle-1 font-weight-light">
                                            <v-icon color="teal" v-if="inscricao.idcargo1 === 'S'">
                                                mdi-check-bold
                                            </v-icon>
                                            <v-icon color="#E53935" v-else>
                                                mdi-close-thick
                                            </v-icon>
                                            <th class="text-left text-subtitle-1 font-weight-bold " >Data de inscrição:</th>
                                            <th class="text-left text-subtitle-1 font-weight-light " >{{inscricao.data_inscricao_1}}</th>
                                        </th>
                                        <th>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn v-bind="attrs"  v-on="on">
                                                        <v-icon color="teal" :disabled="inscricao.idcargo1 === 'N'" @click="emitirComprovanteInscricao(inscricao, '1º CARGO', dados.dadosFuncionario)">
                                                            mdi-download
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Emitir comprovante</span>
                                            </v-tooltip>
                                        </th>
                                        
                                    </tr>
                                    <tr>
                                        <th class="text-left text-subtitle-1 font-weight-bold" >Inscrição extensão carga horária </th>
                                        <th class="text-left text-subtitle-1 font-weight-light">
                                            <v-icon color="teal" v-if="inscricao.idextch === 'S'">
                                                mdi-check-bold
                                            </v-icon>
                                            <v-icon color="#E53935" v-else>
                                                mdi-close-thick
                                            </v-icon>
                                            <th class="text-left text-subtitle-1 font-weight-bold" >Data de inscrição:</th>
                                            <th class="text-left text-subtitle-1 font-weight-light" >{{inscricao.data_inscricao_ext}}</th>
                                        </th>
                                        <th>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn v-bind="attrs"  v-on="on">
                                                        <v-icon color="teal" :disabled="inscricao.idextch === 'N'" @click="emitirComprovanteInscricao(inscricao, 'EXTENSÃO DE CARGA HORÁRIA', dados.dadosFuncionario)">
                                                            mdi-download
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Emitir comprovante</span>
                                            </v-tooltip>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="text-left text-subtitle-1 font-weight-bold " >Inscrição PEB 40hs </th>
                                        <th class="text-left text-subtitle-1 font-weight-light " >
                                            <v-icon color="teal" v-if="inscricao.idpeb40hs === 'S'">
                                                mdi-check-bold
                                            </v-icon>
                                            <v-icon color="#E53935" v-else>
                                                mdi-close-thick
                                            </v-icon>
                                            <th class="text-left text-subtitle-1 font-weight-bold " >Data de inscrição:</th>
                                            <th class="text-left text-subtitle-1 font-weight-light " >{{inscricao.data_inscricao_peb}}</th>
                                        </th>
                                        <th>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn v-bind="attrs"  v-on="on" :disabled="inscricao.idpeb40hs === 'N'">
                                                        <v-icon color="teal" @click="emitirComprovanteInscricao(inscricao, 'PEB 40Hs', dados.dadosFuncionario)">
                                                            mdi-download
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Emitir comprovante</span>
                                            </v-tooltip>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="text-left text-subtitle-1 font-weight-bold " >Justificativa </th>
                                        <th class="text-left text-subtitle-1 font-weight-light " colspan="4">{{ inscricao.dsjustifi }}</th>
                                    </tr>
                                </thead>
                            </v-simple-table>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat>
                <v-card-text>
                    <v-row class="mb-4 p-4" justify="center" v-if="aulasEfetivadasOnlineCargo1.length > 0 && inscricao.idcargo1 === 'S' ">
                        <v-expansion-panels  >
                            <v-expansion-panel>
                                    <v-expansion-panel-header color="#198754" class="text-light text-subtitle-1 font-weight-bold">1º CARGO
                                            <template v-slot:actions>
                                                <v-icon color="white">
                                                mdi-menu-down
                                                </v-icon>
                                            </template>
                                    </v-expansion-panel-header>
                                        <v-expansion-panel-content class="p-4">
                                            <v-simple-table>
                                                <thead style="background-color: #198754;">
                                                    <tr>
                                                        <th class="text-left text-subtitle-1 font-weight-bold text-light" >Escola</th>
                                                        <th class="text-left text-subtitle-1 font-weight-bold text-light" >Disciplina</th>
                                                        <th class="text-left text-subtitle-1 font-weight-bold text-light" >Etapa Escolar</th>
                                                        <th class="text-left text-subtitle-1 font-weight-bold text-light " >Turno</th>
                                                        <th class="text-left text-subtitle-1 font-weight-bold text-light " >Quantidade de aulas </th>
                                                        <th></th>

                                                    </tr>
                                                </thead>
                                                <thead>
                                                    <tr v-for="(aula, index) of aulasEfetivadasOnlineCargo1" :key="index" >
                                                        <th class="text-left text-subtitle-1 font-weight-light">{{aula.nmescola}}</th>
                                                        <th class="text-left text-subtitle-1 font-weight-light">{{aula.dsdiscipl}}</th>
                                                        <th class="text-left text-subtitle-1 font-weight-light">{{`${aula.dsinstruc}/${aula.dsserie}`}}</th>
                                                        <th class="text-left text-subtitle-1 font-weight-light">{{aula.cnperiodo}}</th>
                                                        <th class="text-center text-subtitle-1 font-weight-light">{{aula.qtdaulas}}</th>
                                                        <th :rowspan="aulasEfetivadasOnline.length +1" v-if="index === 0">
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn  v-bind="attrs"  v-on="on" :disabled="inscricao.idcargo1 === 'N'">
                                                                        <v-icon color="#198754" @click="emitirComprovanteEfetivacoes(inscricao, aulasEfetivadasComprovanteCargo1 , '1º CARGO', dados.dadosFuncionario)">
                                                                            mdi-download
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Emitir comprovante</span>
                                                            </v-tooltip>
                                                        </th>
                                                    </tr>
                                                    
                                                </thead>
                                            </v-simple-table>
                                        </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-row>

                    <v-row class="mb-4 p-4" justify="center" v-if="aulasEfetivadasOnlineExt.length > 0 && inscricao.idextch === 'S' ">
                        
                        <v-expansion-panels  >
                            <v-expansion-panel>
                                    <v-expansion-panel-header color="#198754" class="text-light text-subtitle-1 font-weight-bold">EXTENSÃO DE CARGA HORÁRIA
                                            <template v-slot:actions>
                                                <v-icon color="white">
                                                mdi-menu-down
                                                </v-icon>
                                            </template>
                                    </v-expansion-panel-header>
                                        <v-expansion-panel-content class="p-4">
                                             
                                            <v-simple-table>
                                                <thead style="background-color: #198754;">
                                                    <tr>
                                                        <th class="text-left text-subtitle-1 font-weight-bold text-light" >Escola</th>
                                                        <th class="text-left text-subtitle-1 font-weight-bold text-light" >Disciplina</th>
                                                        <th class="text-left text-subtitle-1 font-weight-bold text-light" >Etapa Escolar</th>
                                                        <th class="text-left text-subtitle-1 font-weight-bold text-light " >Turno</th>
                                                        <th class="text-left text-subtitle-1 font-weight-bold text-light " >Quantidade de aulas </th>
                                                        <th></th>

                                                    </tr>
                                                </thead>
                                                <thead>
                                                    <tr v-for="(aula, index) of aulasEfetivadasOnlineExt" :key="index" >
                                                        <th class="text-left text-subtitle-1 font-weight-light" >{{aula.nmescola}}</th>
                                                        <th class="text-left text-subtitle-1 font-weight-light" >{{aula.dsdiscipl}}</th>
                                                        <th class="text-left text-subtitle-1 font-weight-light" >{{`${aula.dsinstruc}/${aula.dsserie}`}}</th>
                                                        <th class="text-left text-subtitle-1 font-weight-light " >{{aula.cnperiodo}}</th>
                                                        <th class="text-center text-subtitle-1 font-weight-light " >{{aula.qtdaulas}}</th>
                                                        <th :rowspan="aulasEfetivadasOnline.length + 1" v-if="index === 0" >
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn v-bind="attrs"  v-on="on" :disabled="inscricao.idextch === 'N'">
                                                                        <v-icon color="#198754" @click="emitirComprovanteEfetivacoes(inscricao, aulasEfetivadasComprovanteExt , 'EXTENSÃO DE CARGA HORÁRIA', dados.dadosFuncionario)">
                                                                            mdi-download
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Emitir comprovante</span>
                                                            </v-tooltip>
                                                        </th>
                                                    </tr>
                                                </thead>
                                            </v-simple-table>
                                        </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-row>

                    <v-row class="mb-4 p-4" justify="center" v-if="aulasEfetivadasOnlinePEB40Hs.length > 0 && inscricao.idpeb40hs === 'S' ">
                        <v-expansion-panels  >
                            <v-expansion-panel>
                                    <v-expansion-panel-header color="#198754" class="text-light text-subtitle-1 font-weight-bold">PEB 40HS
                                            <template v-slot:actions>
                                                <v-icon color="white">
                                                mdi-menu-down
                                                </v-icon>
                                            </template>
                                    </v-expansion-panel-header>
                                        <v-expansion-panel-content class="p-4">
                                            <v-simple-table>
                                                <thead style="background-color: #198754;">
                                                    <tr>
                                                        <th class="text-left text-subtitle-1 font-weight-bold text-light" >Escola</th>
                                                        <th class="text-left text-subtitle-1 font-weight-bold text-light" >Disciplina</th>
                                                        <th class="text-left text-subtitle-1 font-weight-bold text-light" >Etapa Escolar</th>
                                                        <th class="text-left text-subtitle-1 font-weight-bold text-light " >Turno</th>
                                                        <th class="text-center text-subtitle-1 font-weight-bold text-light " >Quantidade de aulas </th>
                                                        <th></th>

                                                    </tr>
                                                </thead>
                                                <thead>
                                                    <tr v-for="(aula, index) of aulasEfetivadasOnlinePEB40Hs" :key="index" >
                                                        <th class="text-left text-subtitle-1 font-weight-light" >{{aula.nmescola}}</th>
                                                        <th class="text-left text-subtitle-1 font-weight-light" >{{aula.dsdiscipl}}</th>
                                                        <th class="text-left text-subtitle-1 font-weight-light" >{{`${aula.dsinstruc}/${aula.dsserie}`}}</th>
                                                        <th class="text-left text-subtitle-1 font-weight-light " >{{aula.cnperiodo}}</th>
                                                        <th class="text-center text-subtitle-1 font-weight-light " >{{aula.qtdaulas}}</th>
                                                        <th :rowspan="aulasEfetivadasOnline.length + 1" v-if="index === 0">
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn v-bind="attrs"  v-on="on" :disabled="inscricao.idpeb40hs === 'N'">
                                                                        <v-icon color="#198754" @click="emitirComprovanteEfetivacoes(inscricao, aulasEfetivadasComprovantePEB40Hs , 'PEB 40HS', dados.dadosFuncionario)">
                                                                            mdi-download
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Emitir comprovante</span>
                                                            </v-tooltip>
                                                        </th>
                                                    </tr>
                                                </thead>
                                            </v-simple-table>
                                        </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-row>
                </v-card-text>
                </v-card>
            </v-tab-item>
            </v-tabs>
        </v-card>
        
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import perfilProfessor from '../api/perfil-professor'
import {comprovanteInscricao} from '../reports/comprovanteInscricao';
import {comprovante} from '../reports/comprovante';

export default {
    name: 'PerfilProfessor',

    async beforeRouteEnter(to, from, next) {
        

        if(sessionStorage.cdlogin)
        {
            const {data} = await perfilProfessor.index(to.params.aaletivo, to.params.cdpessoal, to.params.cdmatric)
            next(vm => vm.index(data));
        }
        else {
            next('/')
        }
    },
    created() {
        this.aaletivo = this.$route.params.aaletivo
        this.dadosFuncionario = this.$route.params.dadosFuncionario
        this.cdlogin = this.$route.params.cdlogin
        

    },
    mounted() {
    },

    data() {
        return {
            aaletivo: this.$route.params.aaletivo,
            dadosFuncionario: this.$route.params.dadosFuncionario,
            cdlogin: this.$route.params.cdlogin,
            agendamentoExtensaoCH: [],
            agendamentoRankingPEB40Hs: [],
            agendamentoRankingPrimeiroCargo: [],
            //aulasDistribuidas: [],
            aulasEfetivadasOnline: [],
            aulasEfetivadasOnlineCargo1: [],
            aulasEfetivadasOnlineExt: [],
            aulasEfetivadasOnlinePEB40Hs: [],
            aulasEfetivadasComprovanteCargo1: [],
            aulasEfetivadasComprovanteExt: [],
            aulasEfetivadasComprovantePEB40Hs: [],
            inscricao: [],
            pontuacaoRankingExtensaoCH: '',
            posicaoRankingExtensaoCH: '',
            posicaoRankingPEB40Hs: '',
            posicaoRankingPrimeiroCargo: '',
        }
    },
    computed: {
        ...mapGetters(['dados', 'getToken']),
    },
    methods: {

        index(dados) {
            this.agendamentoExtensaoCH = dados.agendamentoExtensaoCH
            this.agendamentoRankingPEB40Hs = dados.agendamentoRankingPEB40Hs
            this.agendamentoRankingPrimeiroCargo = dados.agendamentoRankingPrimeiroCargo
            this.aulasEfetivadasOnline = dados.aulasDistribuidas
            this.inscricao = dados.inscricao,
            this.pontuacaoRankingExtensaoCH = dados.pontuacaoRankingExtensaoCH
            this.posicaoRankingExtensaoCH = dados.posicaoRankingExtensaoCH
            this.posicaoRankingPEB40Hs = dados.posicaoRankingPEB40Hs
            this.posicaoRankingPrimeiroCargo = dados.posicaoRankingPrimeiroCargo
            this.aulasEfetivadasOnline = dados.aulasDistribuidas.filter((element) => element.idonline === 'S')
            this.aulasEfetivadasOnlineCargo1 = this.aulasEfetivadasOnline.filter((element) => element.tpcargo === 1)
            this.aulasEfetivadasOnlineExt = this.aulasEfetivadasOnline.filter((element) => element.tpcargo === 2)
            this.aulasEfetivadasOnlinePEB40Hs = this.aulasEfetivadasOnline.filter((element) => element.tpcargo === 3)

            this.aulasEfetivadasComprovanteCargo1 = this.aulasEfetivadasOnlineCargo1.map((element)=> {
                                                                                            return {
                                                                                                        aaletivo: element.aaletivo,
                                                                                                        nmescola: element.nmescola,
                                                                                                        turno: element.cnperiodo,
                                                                                                        dsdiscipl: element.dsdiscipl,
                                                                                                        qtdaulasselecionadas: element.qtdaulas,
                                                                                                        dsinstruc: element.dsinstruc,
                                                                                                        dsserie: element.dsserie,
                                                                                                    } 
                                                                                        }) 

            this.aulasEfetivadasComprovanteExt = this.aulasEfetivadasOnlineExt.map((element)=> {
                                                                                            return {
                                                                                                        aaletivo: element.aaletivo,
                                                                                                        nmescola: element.nmescola,
                                                                                                        turno: element.cnperiodo,
                                                                                                        dsdiscipl: element.dsdiscipl,
                                                                                                        qtdaulasselecionadas: element.qtdaulas,
                                                                                                        dsinstruc: element.dsinstruc,
                                                                                                        dsserie: element.dsserie,
                                                                                                    } 
                                                                                        }) 

            this.aulasEfetivadasComprovantePEB40Hs = this.aulasEfetivadasOnlinePEB40Hs.map((element)=> {
                                                                                            return {
                                                                                                        aaletivo: element.aaletivo,
                                                                                                        nmescola: element.nmescola,
                                                                                                        turno: element.cnperiodo,
                                                                                                        dsdiscipl: element.dsdiscipl,
                                                                                                        qtdaulasselecionadas: element.qtdaulas,
                                                                                                        dsinstruc: element.dsinstruc,
                                                                                                        dsserie: element.dsserie,
                                                                                                    } 
                                                                                        }) 
                                                              

        },

        async emitirComprovanteInscricao(inscricao, dstpcargo, dadosFuncionario) {
            const dados = {
                dadosDaInscricao: inscricao,
                dstpcargo: dstpcargo,
                dadosFuncionario: dadosFuncionario,
            }
            const dd = await comprovanteInscricao(dados)
            pdfMake.createPdf(dd).download();
        },

        async emitirComprovanteEfetivacoes(inscricao, aulas, dstpcargo, dadosFuncionario) {
            const dados = {
                dadosDaInscricao: inscricao,
                aulasEfetivacao: aulas,
                dstpcargo: dstpcargo,
                dadosFuncionario: dadosFuncionario,
            }
            const dd = await comprovante(dados)
            pdfMake.createPdf(dd).download();
        },

        ehMobile() { 
            if( navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i)
            )
            {
                return true; // está utilizando celular
            }
            else {
                return false; // não é celular
            }
        }
    }

    

    

}
</script>

<style>

.background-educacao {
    background-image: url("../assets/img/login-bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    max-width: 100%;
}

table th {
    border: solid 0.5px;
    border-color: #E0E0E0;
}

/* #app > div > main > div > div > div > div > div.v-item-group.theme--light.v-slide-group.v-tabs-bar.primary--text > div.v-slide-group__wrapper > div {
    background-color: #2D6989;
    color: white;
    border: solid 1px ;
    border-color: #FFFF;
} */
.v-slide-group__wrapper{
    background-color: #2D6989;
    /* border: solid 1px; */
    border-color: #FFFF;
    color: #FFFF;
    
}
.v-tabs-bar__content {
    color: #FFFF;
}

.v-slide-group__content {
    /* color: red; */
    /* background-color: red; */
    color: #FFFF;
}

.v-tab--active {
    color: #FFFF;
    /* background-color: #557f93; */
    background-color: #0082c4;
    font-weight: bolder;
}

.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), 
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, 
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn, 
.theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
    font-weight: normal;
}

/* .mdi:before {
    color: #FFFF;
    font-weight: normal;
} */

/* .botao-download {
    color: #198754;
} */






</style>